import React from 'react';
import {TouchableOpacityProps, Insets} from 'react-native';

import {Container, SendCodeButton, SendCode} from './styles';

interface ButtonTimer extends Omit<TouchableOpacityProps, 'hitSlop'> {
  hitSlop?: Insets;
  timer: number;
}

export function ButtonTimer({timer, ...rest}: ButtonTimer) {
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  return (
    <Container>
      <SendCodeButton activeOpacity={1} {...rest}>
        <SendCode>
          Não recebi o código{' '}
          {timer !== 0 &&
            `(${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
              2,
              '0',
            )})`}
        </SendCode>
      </SendCodeButton>
    </Container>
  );
}
